import { Injectable } from '@angular/core';
import { User } from '../../../shared/models/user';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { ConfigService } from '../config.service';
import { Module } from 'src/app/shared/models/app.config';
import { Router } from '@angular/router';
import { LoaderService } from '../loader/loader.service';


@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  currentUser: User;
  currentUserSubscription: Subscription;

  constructor(
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private loaderService: LoaderService,
    private router: Router
  ) {
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  goToModule(module: Module) {
    if (module.transform) {
      this.loaderService.show();
      window.open(this.getFullUrl(module.url, true), '_self');
    } else {
      this.router.navigateByUrl(module.url);
    }
  }

  getFullUrl(moduleURL: string, isAppendUser: boolean) {
    if (!this.currentUser) { return; }

    if (isAppendUser) {
      return this.configService.partnerCenterOldUrl
        + 'redir.aspx?username=' + this.currentUser.profile.UserName + '&' + 'ReturnUrl=' + moduleURL;
    } else {
      return this.configService.partnerCenterOldUrl + moduleURL;
    }
  }
}
